<!-- `skel(n)` (P/proto-states.js:51). -->
<div class="agu-skeleton" aria-busy="true" aria-label="Loading" role="status">
    @for (card of Cards; track card) {
        <div class="agu-skeleton__card">
            @for (width of Bars; track $index) {
                <i class="agu-skeleton__bar" [class.agu-skeleton__bar--title]="$index === 1" [style.width]="width"></i>
            }
        </div>
    }
</div>
